import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { PERIODS, type Period } from '../lib/period';

/** Today / This Week / This Month / This Year */
export const PeriodToggle = ({ value, onChange }: { value: Period; onChange: (p: Period) => void }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    color="primary"
    value={value}
    onChange={(_e, v: Period | null) => v && onChange(v)}
  >
    {PERIODS.map((p) => (
      <ToggleButton key={p} value={p} sx={{ textTransform: 'none', px: 1.5 }}>
        {p}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
